import { api } from "@/lib/api";

let cached = null;

export const fetchUrgency = (fresh = false) => {
  if (fresh || !cached) cached = api.get("/settings/urgency").then((r) => r.data).catch(() => null);
  return cached;
};
